import React, { useEffect, useState } from 'react';
import { obtenerCategoriasGasto, crearCategoriaGasto, renombrarCategoriaGasto, eliminarCategoriaGasto } from '../services/categoriasGastoService';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';

// Administrar categorías de gasto: crear, renombrar, eliminar.
export default function GestionCategoriasGastoModal({ onCerrar, onCambio }) {
  const { mostrarToast } = useToast();
  const [cats, setCats] = useState(null);
  const [nueva, setNueva] = useState('');
  const [editId, setEditId] = useState(null);
  const [editNombre, setEditNombre] = useState('');
  const [ocupado, setOcupado] = useState(false);

  const cargar = () => obtenerCategoriasGasto().then(setCats).catch((e) => mostrarToast(mensajeAmigable(e), 'error'));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { cargar(); }, []);

  const agregar = async () => {
    if (!nueva.trim()) return;
    setOcupado(true);
    try { await crearCategoriaGasto(nueva); setNueva(''); await cargar(); onCambio && onCambio(); }
    catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(false); }
  };
  const guardarNombre = async () => {
    if (!editNombre.trim()) return;
    setOcupado(true);
    try { await renombrarCategoriaGasto(editId, editNombre); setEditId(null); await cargar(); onCambio && onCambio(); }
    catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(false); }
  };
  const borrar = async (c) => {
    if (!window.confirm(`¿Eliminar la categoría "${c.nombre}"? Los gastos ya registrados conservan su etiqueta.`)) return;
    setOcupado(true);
    try { await eliminarCategoriaGasto(c.id); await cargar(); onCambio && onCambio(); }
    catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(false); }
  };

  const input = { width: '100%', padding: '9px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
  const btn = (bg) => ({ padding: '6px 10px', backgroundColor: bg, color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' });

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1200 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '460px', maxHeight: '88vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, color: 'var(--color-primario,#DB2777)', fontSize: '18px' }}>🏷️ Categorías de gasto</h3>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✕</button>
        </div>
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '14px' }}>
            <input value={nueva} disabled={ocupado} onChange={(e) => setNueva(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && agregar()} placeholder="Nueva categoría..." style={input} />
            <button onClick={agregar} disabled={ocupado} style={{ ...btn('var(--color-primario,#DB2777)'), whiteSpace: 'nowrap' }}>➕ Agregar</button>
          </div>
          {!cats && <p style={{ color: '#6B7280', textAlign: 'center' }}>⏳ Cargando...</p>}
          {cats && cats.map((c) => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0', borderBottom: '1px solid #F3F4F6' }}>
              {editId === c.id ? (
                <>
                  <input value={editNombre} disabled={ocupado} autoFocus onChange={(e) => setEditNombre(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && guardarNombre()} style={{ ...input, flex: 1 }} />
                  <button onClick={guardarNombre} disabled={ocupado} style={btn('var(--k-verde)')}>Guardar</button>
                  <button onClick={() => setEditId(null)} disabled={ocupado} style={{ ...btn('#E5E7EB'), color: '#374151' }}>Cancelar</button>
                </>
              ) : (
                <>
                  <span style={{ flex: 1, fontSize: '14px', color: '#111827' }}>{c.nombre}</span>
                  <button onClick={() => { setEditId(c.id); setEditNombre(c.nombre); }} title="Renombrar"
                    style={{ background: 'none', border: '1px solid #D1D5DB', borderRadius: '6px', cursor: 'pointer', padding: '4px 8px' }}>✏️</button>
                  <button onClick={() => borrar(c)} title="Eliminar"
                    style={{ background: 'none', border: '1px solid #FCA5A5', borderRadius: '6px', cursor: 'pointer', padding: '4px 8px', color: '#DC2626' }}>🗑️</button>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
